export const ID_ADMINISTRATION_STONE = 6;

export const TPAG_CARTAO_CREDIT = '03';

export const TPAG_CARTAO_DEBIT = '04';

export const TPAG_PIX = '17';

export const NAME_ADMINISTRATION_STONE = 'Stone';
